var exports = {
  "kL": "xcc377c0b--d61ac6--container",
  "Sl": "xcc377c0b--d61ac6--image",
  "I2": "xcc377c0b--d61ac6--container--contain",
};

module.exports = exports;
